import React from 'react';
import { Box, Typography } from '@mui/material';
import { Image } from '@mui/icons-material';

const NoImage = ({ 
  width = "100%", 
  height = "100%", 
  minHeight = 200,
  borderRadius = "8px",
  iconSize = 50,
  textSize = "body2",
  bgcolor = "grey.300",
  iconColor = "grey.600",
  textColor = "grey.600",
  text = "No Image"
}) => {
  return (
    <Box sx={{ 
      width, 
      height,
      minHeight,
      bgcolor,
      borderRadius,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1
    }}>
      <Image sx={{ fontSize: iconSize, color: iconColor }} />
      <Typography variant={textSize} color={textColor}>
        {text}
      </Typography>
    </Box>
  );
};

export default NoImage;
